import { Component } from '@angular/core';

@Component({
  selector: 'app-provider-terms',
  templateUrl: './provider-terms.html',
  styleUrls: ['./provider-terms.scss']
})
export class ProviderTermsComponent {}
